import { useCallback, useEffect } from 'react';

import { useTranslation } from 'react-i18next';
import { useHistory } from 'react-router-dom';
import { useContainer } from 'unstated-next';

import InviteStudentsBody from './InviteStudentsBody';
import InviteStudentsContainer from './InviteStudentsContainer';
import InviteStudentsHeader from './InviteStudentsHeader';
import InviteStudentsNav from './InviteStudentsNav';
import SubmitError from './SubmitError';
import SubmitPartialSuccess from './SubmitPartialSuccess';
import Loadable from '../../components/common/loadable';
import { getUrlParam } from '../../utils/url';

const InviteStudents = () => {
    const { ready } = useTranslation('invite_students');
    const { inviteStudentsStatus, returnToRosterUrl, loading } = useContainer(InviteStudentsContainer);
    const history = useHistory();

    const redirectToRoster = useCallback(() => {
        if (getUrlParam('isDemo') === 'true') {
            window.location.href = returnToRosterUrl;
            return;
        }

        history.goBack();
    }, [history, returnToRosterUrl]);

    useEffect(() => {
        if (inviteStudentsStatus === 'SUCCESS') {
            redirectToRoster();
        }
    }, [inviteStudentsStatus, redirectToRoster]);

    if (inviteStudentsStatus === 'ERROR') {
        return <SubmitError />;
    }

    if (inviteStudentsStatus === 'PARTIAL-SUCCESS') {
        return <SubmitPartialSuccess />;
    }

    return (
        <Loadable isLoading={!ready || loading} fullScreen>
            <InviteStudentsHeader />
            <InviteStudentsNav />
            <InviteStudentsBody onCancel={redirectToRoster} />
        </Loadable>
    );
};

export default InviteStudents;
